import _sfc_main from "./component-library101.mjs";
import "./component-library102.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.LinkButton, { staticClass: "play-pause-button", attrs: { "type": "button", "tag": "button", "no-styling": "" }, on: { "click": _setup.handleClick } }, [_vm.isPaused ? _c(_setup.PlayButton, { staticClass: "play-pause-button__svg" }) : _c(_setup.PauseButton, { staticClass: "play-pause-button__svg" })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "e537a6ec",
  null,
  null
);
const PlayPauseButton = __component__.exports;
export {
  PlayPauseButton as default
};
